require('../../../modules/es.array.reduce');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').reduce;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/reduce.js
// module id = 607
// module chunks = 0 1